import type { JSX as LocalJSX } from '@familyjs/core/components';
import React from 'react';

import type { FmlContextInterface } from '../contexts/FmlContext';
import { FmlContext } from '../contexts/FmlContext';
import type { ReactComponentOrElement } from '../models';

import type { FamilyReactProps } from './FamilyReactProps';
import { FmlOverlayManager } from './FmlOverlayManager';
import { FmlAppInner } from './inner-proxies';

type Props = LocalJSX.FmlApp &
  FamilyReactProps & {
    ref?: React.Ref<HTMLFmlAppElement>;
  };

export const FmlApp = /*@__PURE__*/ (() =>
  class extends React.Component<Props> {
    addOverlayCallback?: (id: string, overlay: ReactComponentOrElement, containerElement: HTMLDivElement) => void;
    removeOverlayCallback?: (id: string) => void;

    constructor(props: Props) {
      super(props);
    }

    /*
      Wire up methods to call into FmlOverlayManager
    */
    fmlContext: FmlContextInterface = {
      addOverlay: (id: string, overlay: ReactComponentOrElement, containerElement: HTMLDivElement) => {
        if (this.addOverlayCallback) {
          this.addOverlayCallback(id, overlay, containerElement);
        }
      },
      removeOverlay: (id: string) => {
        if (this.removeOverlayCallback) {
          this.removeOverlayCallback(id);
        }
      },
    };

    render() {
      return (
        <FmlContext.Provider value={this.fmlContext}>
          <FmlAppInner {...this.props}>{this.props.children}</FmlAppInner>
          <FmlOverlayManager
            onAddOverlay={(callback) => {
              this.addOverlayCallback = callback;
            }}
            onRemoveOverlay={(callback) => {
              this.removeOverlayCallback = callback;
            }}
          />
        </FmlContext.Provider>
      );
    }

    static get displayName() {
      return 'FmlApp';
    }
  })();
